import { _ as _objectSpread2 } from './objectSpread2-04e3d2b4.esm.js';
import { _ as _typeof } from './typeof-5c86a240.esm.js';
import 'core-js/modules/es.object.get-prototype-of.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.array.reduce.js';
import 'core-js/modules/web.dom-collections.for-each.js';
import 'core-js/modules/es.object.keys.js';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.array.from.js';
import 'core-js/modules/es.string.iterator.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.set.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.array.concat.js';
import { _ as _defineProperty } from './defineProperty-6a97efcd.esm.js';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.string.includes.js';

// from https://github.com/voodoocreation/ts-deepmerge/blob/master/src/index.ts

// istanbul ignore next
var isObject = function isObject(obj) {
  if (_typeof(obj) === 'object' && obj !== null) {
    if (typeof Object.getPrototypeOf === 'function') {
      var prototype = Object.getPrototypeOf(obj);
      return prototype === Object.prototype || prototype === null;
    }
    return Object.prototype.toString.call(obj) === '[object Object]';
  }
  return false;
};
var merge = function merge() {
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }
  return objects.reduce(function (result, current) {
    if (Array.isArray(current)) {
      throw new TypeError('Arguments provided to ts-deepmerge must be objects, not arrays.');
    }
    Object.keys(current).forEach(function (key) {
      if (['__proto__', 'constructor', 'prototype'].includes(key)) {
        return;
      }
      if (Array.isArray(result[key]) && Array.isArray(current[key])) {
        result[key] = merge.options.mergeArrays ? Array.from(new Set(result[key].concat(current[key]))) : current[key];
      } else if (isObject(result[key]) && isObject(current[key])) {
        result[key] = merge(result[key], current[key]);
      } else {
        result[key] = current[key];
      }
    });
    return result;
  }, {});
};
var defaultOptions = {
  mergeArrays: true
};
merge.options = defaultOptions;
merge.withOptions = function (options) {
  merge.options = _objectSpread2({
    mergeArrays: true
  }, options);
  for (var _len2 = arguments.length, objects = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    objects[_key2 - 1] = arguments[_key2];
  }
  var result = merge.apply(void 0, objects);
  merge.options = defaultOptions;
  return result;
};
var deepMerge = merge;

var pick = function pick(obj, keys) {
  try {
    var objectKeys = Object.keys(obj);
    return keys.filter(function (key) {
      return objectKeys.includes(key);
    }).reduce(function (prev, curr) {
      return _objectSpread2(_objectSpread2({}, prev), {}, _defineProperty({}, curr, obj[curr]));
    }, {});
  } catch (e) {
    throw new Error('Could not pick keys for object.');
  }
};

export { deepMerge as d, pick as p };
